export const VERSION_QUERY_KEY = ['release', 'version'] as const
